import React from 'react';
import { InternalField } from '../components/InternalField';
export const Field = ({ children, ...fieldProps }) => {
    return (React.createElement(InternalField, { fieldType: "field", ...fieldProps }, children));
};
//# sourceMappingURL=Field.js.map